export default __webpack_public_path__ + "static/beacon-landing-hero-725fdadaf6912544760738fdc089ba34.mp4";